import { FC } from "react";
import styled from "styled-components";

interface PageWrapperContainerProps {
	backgroundColor?: string;
}

const PageWrapperContainer = styled.div<PageWrapperContainerProps>`
	display: flex;
	flex-direction: row;
	justify-content: center;
	background-color: ${props => (props.backgroundColor ? props.backgroundColor : "none")};
`;

const PageWrapperSizer = styled.div`
	width: 675px;
	@media (max-width: 675px) {
		width: 100%;
	}
`;

interface PageWrapperProps {
	backgroundColor?: string;
}

const PageWrapper: FC<PageWrapperProps> = props => {
	return (
		<PageWrapperContainer backgroundColor={props.backgroundColor}>
			<PageWrapperSizer>{props.children}</PageWrapperSizer>
		</PageWrapperContainer>
	);
};

export default PageWrapper;
